import { useState, useEffect, useRef } from "react";
import api from "../services/api";


const CustomerPopup = ({ onClose, onConfirm, autoFocusConfirm }) => {
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [list, setList] = useState([]);
  const confirmBtnRef = useRef(null);

  useEffect(() => {
    if (autoFocusConfirm) {
      confirmBtnRef.current?.focus();
    }
  }, [autoFocusConfirm]);

  const search = async value => {
    setMobile(value);

    if (value.length < 3) {
      setList([]);
      return;
    }

    try {
      const res = await api.get("/customers/search", {
        params: { mobile: value }
      });
      setList(res.data || []);
    } catch {
      setList([]);
    }
  };

  const selectCustomer = c => {
    setMobile(c.mobile);
    setName(c.name || "");
    setList([]);
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <h3 style={{ marginBottom: 10 }}>Customer Details</h3>

        {/* MOBILE INPUT + DROPDOWN */}
        <div style={{ position: "relative" }}>
          <input
            placeholder="Mobile Number"
            value={mobile}
            onChange={e => search(e.target.value)}
            autoFocus
            style={input}
          />

          {list.length > 0 && (
            <div style={dropdown}>
              {list.map(c => (
                <div
                  key={c.customer_id}
                  style={item}
                  onClick={() => selectCustomer(c)}
                >
                  <div style={{ fontWeight: 600 }}>{c.mobile}</div>
                  {c.name && (
                    <div style={{ fontSize: 12, color: "#64748b" }}>
                      {c.name}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* NAME INPUT */}
        <input
          placeholder="Customer Name (optional)"
          value={name}
          onChange={e => setName(e.target.value)}
          style={{ ...input, marginTop: 10 }}
        />

        {/* ACTIONS */}
        <div style={actions}>
          <button style={btnCancel} onClick={onClose}>
            Cancel
          </button>
          <button
          ref={confirmBtnRef}
            style={btnConfirm}
            onClick={() =>
              onConfirm({
                customer_mobile: mobile,
                customer_name: name
              })
            }
          >
            Confirm & Print
          </button>
        </div>
      </div>
    </div>
  );
};

/* ================= STYLES ================= */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999
};

const modal = {
  background: "#ffffff",
  padding: 20,
  width: 380,
  borderRadius: 8,
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
};

const input = {
  width: "100%",
  padding: "10px 12px",
  fontSize: 14,
  borderRadius: 6,
  border: "1px solid #cbd5e1",
  outline: "none",
  boxSizing: "border-box" 
};

const dropdown = {
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  background: "#fff",
  border: "1px solid #cbd5e1",
  borderRadius: 6,
  marginTop: 4,
  maxHeight: 160,
  overflowY: "auto",
  zIndex: 10000
};

const item = {
  padding: "8px 12px",
  cursor: "pointer",
  borderBottom: "1px solid #e5e7eb"
};

const actions = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 15
};

const btnCancel = {
  padding: "8px 14px",
  border: "1px solid #cbd5e1",
  background: "#f8fafc",
  cursor: "pointer",
  borderRadius: 6
};

const btnConfirm = {
  padding: "8px 14px",
  border: "none",
  background: "#2563eb",
  color: "#fff",
  cursor: "pointer",
  borderRadius: 6
};

export default CustomerPopup;
